import { render, staticRenderFns } from "./InvoiceModel.vue?vue&type=template&id=54ef1b22"
import script from "./InvoiceModel.vue?vue&type=script&lang=js"
export * from "./InvoiceModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports